//新增暂存功能
import { setStorage, getStorage } from '@/utils/auth'

const expireTime = 1000 * 60 * 60 * 24 // 24h有效
const STAGE_KEY = 'patientSummary'
export default function useStage() {
  let stageData = {}

  // 获取缓存的小结
  const getStageData = id => {
    if (!id) return {}
    stageData = getStorage(STAGE_KEY) || {}
    if (!stageData[id]) return {}
    const { expire, data } = stageData[id] || {}
    const now = new Date().getTime()
    if (now > expire) {
      // 如果缓存失效，则清空处理
      clearStorageData(id)
      return {}
    } else {
      return data || {}
    }
  }
  // 将小结存储本地
  const setStorageData = data => {
    const now = new Date().getTime()
    const { privateId, ...res } = data
    const json = {
      expire: now + expireTime, //设置过期时间
      data: res
    }
    stageData[privateId] = json
    setStorage(STAGE_KEY, stageData)
  }
  // 清空小结
  const clearStorageData = id => {
    if (!id) return
    delete stageData[id]
    setStorage(STAGE_KEY, stageData)
  }
  return {
    getStageData,
    setStorageData,
    clearStorageData,
    stageData
  }
}
